/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-03 15:47:26
 */
import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Space,
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Cascader,
  message,
  Upload,
  Button,
  TreeSelect,
} from "antd";
import {
  uploadFile,
  queryCountryListByTownId,
  queryVillageByCountryId,
} from "@root/common/service";
import { subjectDic } from "@root/common/data/dic";
const { Option } = Select;
const { TextArea } = Input;
export function CountryCaseDiscussion() {
  const formRef = useRef<any>();
  const { subjectData, chinaProvinceData } = useSelector(
    (state: any) => state.directionaries
  );
  const [showModal, setShowModal] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [imgUrlArray, setImgUrlArray] = useState([]);
  /**
   * 通过镇获取乡
   * @param id
   */
  const getCountryListByTownId = async (id: string) => {
    const { data } = await queryCountryListByTownId(id);
    setCountryList(data);
  };
  /**
   * 通过乡获取村
   * @param id
   */
  const getVillageListByCountryId = async (id: string) => {
    const { data } = await queryVillageByCountryId(id);
    setVillageList(data);
  };
  const dataSource = [
    {
      key: "1",
      name: "胡彦斌",
      age: 32,
      address: "西湖区湖底公园1号",
    },
    {
      key: "2",
      name: "胡彦祖",
      age: 42,
      address: "西湖区湖底公园1号",
    },
  ];
  const uploadChange = async (data: any) => {
    const { file } = data;

    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      message.error("请选择正确的文件");
      return false;
    }
    if (imgUrlArray.length >= 9) {
      message.info("最多可上传9张图片");
      return;
    }
    let formData = new FormData();
    formData.append("file", file);
    formData.append("uploadFileType", "image");
    formData.append("folder", "teacher");

    uploadFile(formData).then((res) => {
      const { url, shortUrl } = res;
      setImgUrlArray(imgUrlArray.concat(shortUrl));
      // form.setFieldsValue({
      //   imageUrl: url,
      // });
    });
  };
  const columns = [
    {
      title: "序号",
      key: "index",
    },
    {
      title: "状态",
      key: "age",
    },
    {
      title: "学科",
      key: "address",
    },
    {
      title: "标题",
      key: "address",
    },
    {
      title: "最后一次操作时间",
      key: "address",
    },
    {
      title: "操作",
      key: "address",
      render: (_: any, record: any) => (
        <Space size="middle">
          <a>编辑</a>
          <a>删除</a>
          <a>预览</a>
        </Space>
      ),
    },
  ];
  return (
    <div>
      <Button
        onClick={() => {
          setShowModal(true);
        }}
        type="primary"
      >
        上传病例
      </Button>
      <div
        style={{
          marginTop: "10px",
        }}
      >
        <Table dataSource={dataSource} columns={columns} />
      </div>
      <Modal
        title="填写病例相关信息"
        visible={showModal}
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}
      >
        <Form ref={formRef}>
          <Form.Item
            label="标题"
            name="title"
            rules={[{ required: true, message: "请输入标题" }]}
          >
            <Input maxLength={50} />
          </Form.Item>
          <Form.Item
            label="对应学科"
            name="subjectId"
            rules={[{ required: true, message: "请选择学科" }]}
          >
            <TreeSelect
              showSearch
              style={{ width: "100%" }}
              treeData={subjectDic}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="请选择所在学科"
            />
          </Form.Item>
          <Form.Item
            label="性别"
            name="sex"
            rules={[{ required: true, message: "请选择性别" }]}
          >
            <Select>
              <Option value="0">男</Option>
              <Option value="1">女</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="年龄"
            name="age"
            rules={[{ required: true, message: "请输入年龄" }]}
          >
            <InputNumber min={1} max={100} />
          </Form.Item>
          <Form.Item
            label="民族"
            name="sex"
            rules={[{ required: true, message: "请选择民族" }]}
          >
            <Select>
              <Option value="0">男</Option>
              <Option value="1">女</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="provinceData"
            label="医疗机构所在省市区"
            rules={[
              {
                required: true,
                message: "请选择医疗机构所在省市区",
              },
            ]}
          >
            <Cascader
              options={chinaProvinceData}
              placeholder="请选择医疗机构所在省市区"
              onChange={(e) => {
                console.log(e);
                formRef.current.setFieldsValue({
                  provinceData: e, // 重置县医院选择项
                });
                const [, , districtCode] = e;
                getCountryListByTownId(districtCode as string);
              }}
            />
          </Form.Item>
          <Form.Item name="countryCode" label="医疗机构所在街道、乡、镇">
            <Select
              placeholder="请选择医疗机构所在街道、乡、镇"
              onChange={(value) => {
                getVillageListByCountryId(value);
              }}
            >
              {countryList.map((item: { name: string; code: string }) => (
                <Option value={item.code}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="villageCode" label="所在社区(村)">
            <Select placeholder="请选择所在社区(村)">
              {villageList.map((item: { name: string; code: string }) => (
                <Option value={item.code}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="职业"
            name="sex"
            rules={[{ required: true, message: "请选择职业" }]}
          >
            <Select>
              <Option value="0">男</Option>
              <Option value="1">女</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="主诉"
            rules={[{ required: true, message: "请输入主诉" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="现病史"
            rules={[{ required: true, message: "请输入现病史" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="既往史"
            rules={[{ required: true, message: "请输入既往史" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="个人史"
            rules={[{ required: true, message: "请输入个人史" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="婚育史"
            rules={[{ required: true, message: "请输入婚育史" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="月经史"
            rules={[{ required: true, message: "请输入月经史" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="家族史"
            rules={[{ required: true, message: "请输入家族史" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="体格检查"
            rules={[{ required: true, message: "请输入体格检查" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="辅助检查"
            rules={[{ required: true, message: "请输入辅助检查" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>
          <Form.Item
            name="villageCode"
            label="初步诊断"
            rules={[{ required: true, message: "请输入初步诊断" }]}
          >
            <TextArea maxLength={1000} showCount />
          </Form.Item>

          <Form.Item
            label="讲师头像"
            name="imageUrl"
            valuePropName="fileList"
            rules={[
              {
                required: true,
                message: "请选择讲师头像",
              },
            ]}
          >
            <>
              <Input type="hidden" />
              {imgUrlArray.map((url) => (
                <p>
                  <img src={url} style={{ maxWidth: "100%" }} alt="" />
                </p>
              ))}
              <Upload
                className="course-uploader"
                showUploadList={false}
                customRequest={uploadChange}
              >
                <p>* 最多可上传9张图片，请拍照清晰</p>
                <Button>选择文件</Button>
              </Upload>
            </>
          </Form.Item>
          <Space
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button type="primary" htmlType="submit">
              保存
            </Button>
            <Button>提交</Button>
            <Button type="primary">预览</Button>
          </Space>
        </Form>
      </Modal>
    </div>
  );
}
